import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		tags: {
			maxHeight: 128,
			overflowY: "auto",
		},
	} satisfies Record<string, CSSObject>);